<template>
    <div class="content_collapse_block">

        <div class="inner-content"
             v-bind:class="initialstate?'open':''"
             v-bind:style="{height:size + 'px' , transitionDuration: speed + 'ms'}"
        >
            <div class="measure" v-html="content.text"></div>
        </div>
        <button class="toogle-button btn" v-on:click="toggleCollapse()">
            <span v-html="label"></span>
            <div class="arrow-icon"></div>
        </button>

    </div>
</template>

<script>
    export default {
        props: ['settings', 'content'],
        data: () => {
            return {
                initialstate: false,
                size: 300,
                speed: 300,
                originalSize: 0,
                currentState: false,
            }
        },
        computed:{
            label: function(){
                return this.currentState ? this.content.labelOpened : this.content.labelClosed;
            }
        },
        methods: {
            toggleCollapse (element) {
                let collapseBlock

                if(element !== undefined){
                    collapseBlock = $(element);
                }else{
                    collapseBlock = $(this.$el).parent();
                }

                let innerBlock = collapseBlock.find('.inner-content');
                    innerBlock.toggleClass('open');

                let openHeight = collapseBlock.find('.measure').height();
                if(innerBlock.attr('class').indexOf('open') !== -1) {
                    this.size = openHeight; //oppened
                }else{
                    this.size = this.originalSize; //closed
                }
                this.currentState = this.size !== this.originalSize;
            }
        },
        mounted() {
            this.speed = this.settings.speed;
            this.label = this.settings.label;

            this.size = this.settings.size;
            this.originalSize = this.size;
            if(this.settings.initialstate) {
                this.toggleCollapse(this.$el);
            }
            this.currentState = this.settings.initialstate;
        }
    }
</script>
